import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { Flip } from "gsap/Flip";
import { prefersReducedMotion } from "@/utils/media";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(ScrollTrigger, Flip, CustomEase);

CustomEase.create("smooth", "0.5, 0, 0, 1");
CustomEase.create("natural", "0.8, 0, 0.2, 1");
CustomEase.create("accelerate", "1, 0, 1, 1");
CustomEase.create("ease", "0, 0, 1, 1");

const defaults = {
  ease: "ease",
  duration: 0.8,
};

gsap.defaults(defaults);

const reduced = prefersReducedMotion();

export default gsap;
export { defaults, reduced, ScrollTrigger, SplitText, Flip };
